import { toJS } from 'mobx';
import { message, Modal } from 'antd';
import service from '@service/index';

const confirm = Modal.confirm;

class ExportData {
  /**
   * 数据导出
   */
  async exportData() {
    if(this.export_data_url === undefined) {
      console.error('this.export_data_url is undefined.');
      return;
    }

    let result = await service.fetchData({
      path: this.export_data_url,
      params: toJS(this.filter_store)
    });

    if(result.success) {
      confirm({
        title: '确认导出',
        content: '确认导出该数据？',
        onOk() {
          window.open(result.data)
        },
        onCancel() {

        }
      });
    } else {
      message.error(result.error.error_data);
    }
  }
}

export default ExportData;



// WEBPACK FOOTER //
// ./src/Store/Base/ExportData.js